import type { Theme } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

const darkModeTheme: Theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#007A8C',
        },
        secondary: {
            main: '#9C27B0',
        },
        error: {
            main: '#D1232C',
        },
        info: {
            main: '#0288D1',
        },
        background: {
            default: '#2D3034',
            paper: '#1C1F22',
        },
        text: {
            primary: '#FFFFFF',
        },
    }, 
});

export default darkModeTheme;